module.exports = __webpack_public_path__ + "static/media/siddharth-bike.d0e8db1a.jpg";